import { Paper, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

interface Props {
  title: string;
  children: ReactElement;
}

const DataCard = ({ title, children }: Props) => {
  return (
    <Paper sx={{ width: '100%', p: 2 }}>
      <Stack spacing={2}>
        <Stack
          spacing={2}
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography variant="h4">{title}</Typography>
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default DataCard;
